// Development-only; do not send request bodies or arbitrary console objects.
if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
  const endpoint = 'http://127.0.0.1:8892/events'
  const redact = value => String(value == null ? '' : value)
    .replace(/(Bearer\s+)\S+/gi, '$1[redacted]')
    .replace(/((?:token|password|secret|authorization|api[_-]?key)\s*[:=]\s*)\S+/gi, '$1[redacted]')
    .replace(/https?:\/\/\S+/gi, '[url]')
    .slice(0, 2000)
  const send = (type, message) => {
    try {
      fetch(endpoint, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({type, message: redact(message)}), keepalive: true}).catch(() => {})
    } catch (_) {}
  }
  for (const type of ['error', 'warn']) {
    const original = console[type]
    console[type] = function (...args) {
      send(type, args.map(arg => typeof arg === 'string' ? arg : arg instanceof Error ? arg.message : '[object]').join(' '))
      return original.apply(this, args)
    }
  }
  window.addEventListener('error', event => send('window-error', event.message))
  window.addEventListener('unhandledrejection', event => send('unhandledrejection', event.reason instanceof Error ? event.reason.message : '[rejection]'))
}
